import React, { useEffect } from 'react'
import { swapRedirectToken, logout } from '../../actions/authentication'

export default function AuthPage() {
  useEffect(() => {
    let pendingLogin = localStorage.getItem('pendingLogin')
    if (pendingLogin) {
      pendingLogin = JSON.parse(pendingLogin)
    } else {
      logout(true)
    }
    const urlParams = new URLSearchParams(window.location.search)
    const token_param = urlParams.get('token')
    if (pendingLogin && token_param) {
      localStorage.clear()
      swapRedirectToken(token_param, pendingLogin.pkce_unhashed)
    }
  }, [])
  return <React.Fragment />
}
